import { createFileRoute } from '@tanstack/react-router';

import { HelplineDemandListScreen } from '@/features/helpline-demand/components/HelplineDemandListScreen';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/_staff/admin/workspace/helpline-demand/')({
  beforeLoad: () => {
    requirePermission('session:read');
  },
  component: HelplineDemandListScreen,
  staticData: { crumb: 'Helpline demand' },
});
